export default __webpack_public_path__ + "static/media/terms-and-conditions.ce187e80.svg";